module.exports = __webpack_public_path__ + "static/media/Tick.e67876ac.svg";